<script setup lang="ts">
import { onMounted } from 'vue'
import { useSessionStore } from '@/stores/session'

const session = useSessionStore()

onMounted(() => {
  if (session.setupComplete === null) void session.load()
})
</script>

<template>
  <div v-if="session.loading" class="boot">Wird geladen …</div>
  <RouterView v-else />
</template>

<style scoped>
.boot {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  color: var(--txt3);
  font-size: 13px;
}
</style>
